import { FC } from 'react';
import { Link, PlainLink } from 'components/link/link';
import type { DivisionOrderResult } from './types';

// Prefer the Insights entity link when an entity match exists (TitleEntityLink),
// regardless of source. Fall back to the SF.com link for Salesforce rows
// without a matched entity.
const OperatorCellContent: FC<{
  operator: DivisionOrderResult['operator'];
}> = ({ operator }) => {
  if (!operator?.name) return <>--</>;
  if (operator.entityHref) {
    return <Link to={operator.entityHref}>{operator.name}</Link>;
  }
  if (operator.salesforceHref) {
    return (
      <PlainLink
        href={operator.salesforceHref}
        target="_blank"
        rel="noreferrer"
      >
        {operator.name}
      </PlainLink>
    );
  }
  return <>{operator.name}</>;
};

export { OperatorCellContent };
